exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".profile[data-v-6c9f82f1]{background:#805f41;border-radius:50px 0 0 50px;cursor:pointer}.scanner[data-v-6c9f82f1]{font-size:40px;font-weight:700;color:#805f41;cursor:pointer}", "", {"version":3,"sources":["D:/xampp/htdocs/open_house/ui/src/components/layouts/FooterbarView.vue"],"names":[],"mappings":"AACA,0BACE,mBAAoB,AACpB,4BAAiC,AACjC,cAAgB,CACjB,AACD,0BACE,eAAgB,AAChB,gBAAiB,AACjB,cAAe,AACf,cAAgB,CACjB","file":"FooterbarView.vue","sourcesContent":["\n.profile[data-v-6c9f82f1] {\r\n  background: #805f41;\r\n  border-radius: 50px 0px 0px 50px;\r\n  cursor: pointer;\n}\n.scanner[data-v-6c9f82f1] {\r\n  font-size: 40px;\r\n  font-weight: 700;\r\n  color: #805f41;\r\n  cursor: pointer;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6c9f82f1","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/FooterbarView.vue
// module id = 304
// module chunks = 0 1